import { render, staticRenderFns } from "./ObjectTree.vue?vue&type=template&id=3f22b32a"
import script from "./ObjectTree.vue?vue&type=script&lang=js"
export * from "./ObjectTree.vue?vue&type=script&lang=js"
import style0 from "./ObjectTree.vue?vue&type=style&index=0&id=3f22b32a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports